<template lang="pug">
.notice-container(v-if="list.length>0")
  .go-horse(
    ref="box"
    :style="styles"
  )
    .border-bkg(
      v-for="(item, index) in list"
      :key="index"
      ref="item"
    )
      slot(:itemData="item" :index="index" )
</template>

<script>

const regNumber = /^\d+$/;
export default {
  name: 'Carousel',
  props: {
    autoplay: {
      validator(val) {
        return regNumber.test(val);
      },
      default: 3000,
    },
    speed: {
      validator(val) {
        return regNumber.test(val);
      },
      default: 500,
    },
    dataList: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      indexMq: 0,
      timer: null,
      styles: {
        top: 0,
        transitionDuration: 0,
      },
      list: this.dataList,
    };
  },
  computed: {
    lenMq() {
      return this.list ? this.list.length : 0;
    },
    height() {
      if (this.$refs.item) {
        const { height } = this.$refs.item[0].getBoundingClientRect() || {};
        return height;
      }
      return 0;
    },
  },
  mounted() {
    this.timer = setInterval(() => {
    // eslint-disable-next-line no-plusplus
      this.setTop(this.speed, -(++this.indexMq * this.height));
      if (this.indexMq >= this.lenMq) {
      // 若当前是新1(最後一個)，
        const template = this.list;
        this.list = this.list.concat(template);
        setTimeout(() => {
          this.list.splice(0, template.length);
          // 瞬间回到老1（第一个）
          this.indexMq = 0;
          this.setTop(0, 0);
        }, this.speed);
      }
    }, this.autoplay);
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
    this.indexMq = 0;
  },
  methods: {
    setTop(speed, top) {
      this.styles.transitionDuration = `${speed}ms`;
      this.styles.top = `${top}px`;
    },
  },
};
</script>

<style lang="less" scoped>
.notice-container {
  // 容器宽、高、背景图等等可以由外部父组件自定义
  flex-shrink: 0;
  overflow: hidden;
  position: relative;

  .go-horse {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;

    .border-bkg {
      display: flex;
      justify-content: flex-start;
    }
  }
}
</style>
